import React, { FC } from 'react'
import styles from 'styles/components/modal.module.scss'
import { HorizontalLine, Spacer } from 'components/Utility'
import { useFixedBackface } from 'hooks/effect'

type Props = {
  open: boolean
  closeModal: () => void
  tel: string
}

const TelModal: FC<Props> = (props) => {
  const { open, closeModal, tel } = props

  // モーダルOPEN時に背景を固定する（スクロールを禁止する）
  useFixedBackface(open, [open])

  return (
    <div className={open ? styles.open : ''} data-cy={'tel-modal'}>
      <div className={styles.overlay}>
        <div className={styles.overlay__background} onClick={closeModal} />
        <section className={styles.tel} data-cy={'tel-modal-section'}>
          <div className={styles.tel__box}>
            <p className={styles.tel__box__label}>こちらの電話番号に発信しますか？</p>
            <HorizontalLine verticalMargin={16} />
            <a className={styles.tel__box__link} href={`tel:${tel}`} role={'button'}>
              {tel}
            </a>
          </div>
          <Spacer size={10} />
          <button className={styles.tel__box} data-cy={'tel-modal-cancel-button'} onClick={closeModal}>
            <span className={styles.tel__box__link}>キャンセル</span>
          </button>
        </section>
      </div>
    </div>
  )
}

export default TelModal
